export default "__VITE_ASSET__DkWQBNkf__"